// extracted by mini-css-extract-plugin
module.exports = {"button":"ResourceReviewThumbActions_button__oAtAk","mantine-Button-leftIcon":"ResourceReviewThumbActions_mantine-Button-leftIcon__34_de"};